import React from "react";


import {WEBSERVER} from "../services/globals";
const payment = WEBSERVER + '/checkout2'; 
const cart = WEBSERVER + '/cart'; 
const address = WEBSERVER + '/checkout1'; 


export default function Checkoutnavi({step}) {
  let path =`<a href="${WEBSERVER}">Home</a>/`;
  if (step==0) {
  return  (
    <div className="row checkoutnavi">
      <div className="col-md-4 h4"><a href={cart}>Warenkorb</a></div>
      <div className="col-md-4 h4">Adresse</div>
      <div className="col-md-4 h4">Versand + Zahlung</div>
    </div>
  );
  }
  if (step==1) {
    return  (
      <div className="row checkoutnavi">
        <div className="col-md-4 h4"><a href={cart}>Warenkorb </a></div>
        <div className="col-md-4 h4"><a href={address}>Adresse</a></div>
        <div className="col-md-4 h4">Versand + Zahlung</div>
      </div>
    );
    }
    if (step==2) {
      return  (
        <div className="row checkoutnavi">
          <div className="col-md-4 h4"><a href={cart}>Warenkorb </a></div>
          <div className="col-md-4 h4"><a href={address}>Adresse</a></div>
          <div className="col-md-4 h4"><a href={payment}>Versand + Zahlung</a></div>
        </div>
      );
      }
    }
